import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Button } from 'components/alf-design';
import { HomeIcon, UserCircleIcon, HelpCircleIcon } from 'assets/icon';
import { logo } from 'assets/img';
import AdminPage from 'components/dashboard/AdminPage';
import { useAuth0 } from 'utils';

const AppBar = ({ onHelp, onUserProfile, onHome }) => {
  const { pathname } = useLocation();
  const isDashboard = pathname === '/';
  const isProfile = pathname === '/user-profile';
  const isFaq = pathname === '/help';
  const { user } = useAuth0();
  const isAdmin = user
    ? user?.email?.includes('@slideinsurance.com') && user?.role?.isAdmin
    : false;

  return (
    <header
      className="relative flex justify-between items-center w-full bg-white border-b border-legacy-borderLight py-[24px]"
      role="banner"
    >
      <nav className="flex w-full lg:mx-[108.5px] px-[24px] justify-between items-center">
        <div className="flex">
          <img
            src={logo}
            alt="Slide Insurance dashboard"
            className="w-[112px]"
          />
        </div>
        {isAdmin && (
          <div className="flex flex-1 justify-end mx-[24px]">
            <AdminPage isSearchView={false} />
          </div>
        )}
        <div className="grid grid-cols-3 gap-x-[16px]">
          <div
            className={
              isDashboard
                ? 'border-b-2 border-legacy-primary pb-[5px] ml-16'
                : 'ml-16'
            }
          >
            <Button
              id="Home-Icon"
              ariaLabel="Home"
              type="icon"
              onClick={onHome}
              icon={<HomeIcon aria-label="Slide Insurance dashboard" />}
              link
            />
          </div>
          <div
            className={
              isProfile
                ? 'border-b-2 border-legacy-primary pb-[5px] ml-16'
                : 'ml-16'
            }
          >
            <Button
              id="User-Profile-Icon"
              ariaLabel="My profile"
              type="icon"
              onClick={onUserProfile}
              icon={<UserCircleIcon aria-label="My profile" />}
              link
            />
          </div>
          <div
            className={
              isFaq
                ? 'border-b-2 border-legacy-primary pb-[5px] ml-16'
                : 'ml-16'
            }
          >
            <Button
              id="app-bar-help"
              ariaLabel="Frequently asked questions"
              type="icon"
              onClick={onHelp}
              icon={<HelpCircleIcon aria-label="Frequently asked questions" />}
              link
            />
          </div>
        </div>
      </nav>
    </header>
  );
};

AppBar.propTypes = {
  onHelp: PropTypes.func.isRequired,
  onUserProfile: PropTypes.func.isRequired,
  onHome: PropTypes.func.isRequired,
};

export default AppBar;
